<template>
<div class="content">
  <list
    :title="$t(`pages.${ $options.module }.list.title`)"
    :count="count"
    :lang="lang"
    @new="newItem"
    @language="changeLang"
  >
    <template v-slot:default>
      <list-item
        v-for="item in list"
        :key="item.id"
        :config="$options.listItemConfig"
        :state="item.state"
      >
        <router-link :to="`/${ $options.module }/view/${item.id}`" class="notifications-list-item">
            <div class="notifications-list-date">
                {{ formatDateTime(item.senton) }}
            </div>
            <div class="notifications-list-title-row">
                <div class="notifications-list-title">{{ getItemTitle(item) }}</div>
                <div class="notifications-list-countries">{{ getCountriesListForItem(item) }}</div>
            </div>
        </router-link>
      </list-item>
    </template>
    <template v-slot:extras>
        <pop-down
            v-if="pop.active"
            :class="pop.className"
            @close="popClose"
        >
            {{ pop.message }}
        </pop-down>
    </template>
  </list>
    <pagination :module="this.$options.module" />
</div>
</template>

<script>
import ListMixin from '@/components/list/ListMixin';
import { defaultLanguage } from '@/config/languages';
import PopDownMixin from '@/components/PopDownMixin';
import Pagination from '@/components/list/Pagination.vue';
import formatDateTime from '../../utils/formatDate';

export default {
    mixins: [ListMixin, PopDownMixin],
    name: 'NotificationsList',
    module: 'notifications',
    listItemConfig: {},
    components: {
        Pagination,
    },
    computed: {
        list() {
            return this.$store.state[this.$options.module].list;
        },
        count() {
            return this.$store.state[this.$options.module].count;
        },
    },
    async created() {
        await this.$store.dispatch('countries/list');
    },
    methods: {
        compareTitles(firstEl, secondEl) {
            const firstTitle = (firstEl && firstEl.senton) || '';
            const secondTitle = (secondEl && secondEl.senton) || '';

            if (firstTitle > secondTitle) {
                return -1;
            }
            if (firstTitle > secondTitle) {
                return 1;
            }

            return 0;
        },
        getCountriesListForItem(item) {
            if (item.countryids.length === 0) {
                return this.$t(`pages.${ this.$options.module }.form.values.allUsers`);
            }

            const countries = item.countryids.map((id) => this.$store.getters['countries/getById'](id));
            let countriesString = countries
                .filter((country) => !!country)
                .map((country) => (country.locales[this.lang] && country.locales[this.lang].name) || country.locales[defaultLanguage].name)
                .join(', ');

            if (item.regioncodes.length) {
                countriesString += ` (${ item.regioncodes.join(', ').replace(this.$t('general.form.no_region'), this.$t('general.form.no_region_title')) })`;
            }
            return countriesString;
        },
        formatDateTime,
    },
};
</script>
